import angular from 'angular';
import businessEmailMailTemplates from './businessEmailMailTemplates';

export default angular
  .module('businessEmailMailTemplates.scenes', [])
  .component('businessEmailMailTemplates', businessEmailMailTemplates).name;
